<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_new_course") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="6"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
            :preSelectedImage="data.image?.path"
            :acceptVideo="true"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_iden')"
            @selectImage="selectVideo"
            :preSelectedImage="data.video?.path"
            :acceptVideo="true"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.desc_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.desc_en"
            required
          />
          <base-select-input
            col="6"
            :optionsList="academic_stages"
            :placeholder="$t('PLACEHOLDERS.academic_stage')"
            v-model="data.academic_stage"
          />
          <base-select-input
            col="6"
            :optionsList="academic_years"
            :placeholder="$t('PLACEHOLDERS.academic_year')"
            v-model="data.academic_year"
          />
          <base-select-input
            col="6"
            :optionsList="levels"
            :placeholder="$t('PLACEHOLDERS.course_level')"
            v-model="data.level"
          />
          <div class="row justify-content-center">
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>

            <div
              class="col-l2"
              v-for="(item, index) in skills"
              :key="'l' + index"
            >
              <div class="item w-full d-flex align-items-center col-l2">
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.skill_ar')"
                  v-model.trim="item.ar"
                />
                <base-input
                  col="6"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.skill_en')"
                  v-model.trim="item.en"
                />

                <div class="all_actions" v-if="skills?.length > 1">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeRow(index)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CreateBanks",
  
  computed: {
    levels() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.beginner"),
          value: "beginner",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.intermediate"),
          value: "intermediate",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.advanced"),
          value: "advanced",
        },
      ];
    },
  },
  watch: {
    "data.academic_stage"(newVal) {
      this.data.academic_year = null;
      if (newVal) this.getAcademicYears(newVal.id);
    },
  },
  data() {
    return {
      isWaitingRequest: false,

      file: null,
      fileType: "",
      academic_years: [],
      academic_stages: [],
      skills: [{ ar: "", en: ""
}],
      // Start:: Data Collection To Send
      data: {
        academic_year: null,
        academic_stage: null,
        name_ar: null,
        level: null,
        name_en: null,
        image: null,
        video: null,
        desc_ar: null,
        desc_en: null,
        active: true,
      },
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    addRow() {
      this.skills.push({ ar: "", en: "" });
    },
    removeRow(index) {
      this.skills.splice(index, 1);
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectVideo(selectedVideo) {
      this.data.video = selectedVideo;
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null;
      this.fileType = "";
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    async getAcademicStages() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "academic-stages?page=0&limit=0&is_active=1",
        });
        this.academic_stages = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getAcademicYears(stage_id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `academic-years?page=0&limit=0&is_active=1&academic_stage=${stage_id}`,
        });
        this.academic_years = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.desc_ar) {
        REQUEST_DATA.append("description[ar]", this.data.desc_ar);
      }
      if (this.data.desc_en) {
        REQUEST_DATA.append("description[en]", this.data.desc_en);
      }
      if (this.data.academic_stage) {
        REQUEST_DATA.append("academic_stage_id", this.data.academic_stage.id);
      }
      if (this.data.academic_year) {
        REQUEST_DATA.append("academic_year_id", this.data.academic_year.id);
      }
      if (this.data.level) {
        REQUEST_DATA.append("level", this.data.level.value);
      }
      if (this.skills) {
        this.skills.forEach((skill, i) => {
          if (skill.ar) {
            REQUEST_DATA.append(`skills[${i}][ar]`, skill.ar);
          }
          if (skill.en) {
            REQUEST_DATA.append(`skills[${i}][en]`, skill.en);
          }
        });
      }
      if (this.data.academic_year) {
        REQUEST_DATA.append("academic_year_id", this.data.academic_year.id);
      }
      if (this.data.image?.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.video?.file) {
        REQUEST_DATA.append("video", this.data.video.file);
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `courses`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/courses/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },
  created() {
    this.getAcademicStages();
    // this.getAcademicYears();
  },
};
</script>
